import styled from 'styled-components';
import { media } from '../../../../Utils/mediaQueries';
import ManImage from '../../../../Assets/Icons/man-image.png';

// export const LeftBox = styled.div`
//     width: 480px;
//     height: 100%;
//     background-color: #000000;

//     ${media.desktop`
//         width: 300px;
//     `};

//     ${media.tablet`
//         display: none;
//     `};
// `;

export const RightBox = styled.div`
    width: 100%
    height: 100%;
    display: flex;

    // ${media.desktop`
    //     width: calc(100% - 300px);
    // `};
    // ${media.tablet`
    //     width: 100%;
    // `};
`;

export const LeftBox = styled.div`
    width: 500px;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.15);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    ${props => {
        if (!props.hideDefault) {
            return `
                background-image: url(${ManImage});
                background-repeat: no-repeat;
                background-size: 70%;
                background-position: bottom left;
            `;
        }
    }} ${media.desktop`
        width: 300px;
        background-size: 300px;
    `};

    ${media.tablet`
        display: none;
    `};
`;

export const LeftBoxContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 15px;
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    // align-items: center;
    position: relative;

    display: flex;
    flex-direction: column;
`;

export const TopRowContainer = styled.div`
    height: 80px;
    width: 100%;
`;

export const TopRow = styled.div`
    position: absolute;
    left: 20px;
    top: 24px;
    display: flex;
    align-items: center;
    z-index: 111;
`;

export const SlideContainer = styled.div`
    background-image: ${props => {
        if (props.backgroundImage) {
            if (props.backgroundImage.includes('https')) return `url(${props.backgroundImage})`;
        }
        return props.backgroundImage;
    }};
    background-size: cover;
    min-height: 100vh;
    height: auto;
    position: relative;
    padding-left: 500px;

    ${media.desktop`
        padding-left: 300px;
    `};

    ${media.tablet`
        padding-left: 0;
    `};
`;

export const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const InnerPadding = styled.div`
    padding: 15px;
`;

export const OuterMargin = styled.div`
    margin: ${props => (props.margin ? props.margin : '10px')};
`;

export const AppStoreButton = styled.div`
    width: 135px;
    height: 40px;
    background-image: ${props => ` url(${props.url})`};

    border-radius: 3px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
`;

export const InnerMargin = styled.div`
    margin: 15px 0;
`;

export const Circles = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const HeaderIcon = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 100%;

    & > div {
        height: 48px;
        width: 48px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        position: absolute;
    }
`;

export const BackgroundImage = styled.img`
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
`;

export const Container = styled.div`
    width: 150px;
    height: 150px;

    ${media.tablet`
        width: 100px;
        height: 100px;
        
    `};

    ${media.phone`
        order: -1;
        display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : null)}
    `};
`;

export const LeaderboardIconPlaceholder = styled.div`
    position: relative;
    width: 150px;
    height: 100%;

    ${media.tablet`
        width: 100px
    `};
`;

export const OpacityOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${props => (props.isDarkeningLayerApplied ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0.1)')};
    top: 0;
    left: 0;
`;

export const RowTopSliderLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    ${media.phone`
        flex-direction: column;
    `};
`;

export const QRCodeContainer = styled.div`
    width: 100%;
    height: 130px;
    border-radius: 16px;
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    background-color: rgba(5, 5, 5, 0.22);
    padding: 16px;
    display: flex;
    align-items: center;
`;

export const QRCodeBox = styled.div`
    min-width: 95px;
    min-height: 95px;
    background-color: ${props => (props.isEmpty ? 'none' : 'white')};
    border: ${props => (props.isEmpty ? 'none' : '2px solid white')};
    display: flex;
    justify-content: center;
    align-items: center;
`;



// WEBPACK FOOTER //
// ./src/UI/App/pages/LeaderBoardsCarusel/style.js